import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';

import HomepageApp from '../../apps/Homepage';
import MobileBannerApp from '../../apps/MobileBanner';
import CategoryMenuBarApp from '../../apps/CategoryMenuBar/CategoryMenuBar';
import SmartBannerFullScreenApp from '../../apps/SmartBannerAndroidApp/SmartBannerFullScreenApp/SmartBannerFullScreenApp';
import { trackGAEvent } from '../../utils/gaTracking';

import '../../../scss/global.scss';
// server side only components styles for this page
import '../../../../server/pages/homepage.styles';

const renderClientRoot = (root: HTMLElement | null, element: React.ReactNode) => {
  if (!root) {
    return;
  }

  if (root.hasChildNodes()) {
    hydrateRoot(root, element);
    return;
  }

  createRoot(root).render(element);
};

export default function homepage(i18n: any) {
  const appState = window.__CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const smartBannerAndroidRoot = document.getElementById('smart-banner-android-root');
  const categoryMenuBarRoot = document.getElementById('category-menu-bar-root');
  const topBlockRoot = document.getElementById('top-block-root');
  const homepageRoot = document.getElementById('homepage-root');
  const { showSmartBanner } = environment;

  if (showSmartBanner) {
    renderClientRoot(
      smartBannerAndroidRoot,
      <I18nContextProvider i18nInstance={i18n}>
        <SmartBannerFullScreenApp environment={environment} />
      </I18nContextProvider>,
    );
  }

  // Header is server side rendered in express-react library
  renderClientRoot(headerRoot, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  renderClientRoot(
    categoryMenuBarRoot,
    <I18nContextProvider i18nInstance={i18n}>
      <CategoryMenuBarApp appState={appState} environment={environment} />
    </I18nContextProvider>,
  );

  renderClientRoot(topBlockRoot, <MobileBannerApp environment={environment} />);

  renderClientRoot(
    homepageRoot,
    <I18nContextProvider i18nInstance={i18n}>
      <HomepageApp appState={appState} environment={environment} />
    </I18nContextProvider>,
  );
}
